import T from 'i18n-react'
import { createSelector } from 'reselect'

import {
  createSelectorWithPath,
  labelSelectorFunc,
  entitiesSelector
} from 'helpers/ComponentSelectorUtil'

const valuesSelectorFunc = state => state.values
const featuresSelectorFunc = state => state.features
const connectorSourcesSelectorFunc = state => state.connectorSources
const connectorTypesSelectorFunc = state => state.connectors
const locationsSelectorFunc = state => state.locations
const linksSelectorFunc = state => state.links
const getValuesSelector = (path, id) => {
  const selector = createSelectorWithPath(`${path}.${id}`, valuesSelectorFunc)
  return (state) => ({ validationObject: selector(state) })
}

const connectorSourcesSelectorHoc = (connectorSourcesSelector) => (
  createSelector(
    entitiesSelector,
    connectorSourcesSelector,
    (entities, refs) => refs.map(({id, type}) => {
      const value = entities[type][id].value
      return { value, label: value }
    })
  )
)

const featuresSelectorHoc = (featuresSelector) => (
  createSelector(
    entitiesSelector,
    featuresSelector,
    (entities, refs) => refs.map(({id, type}) => {
      const value = entities[type][id].value
      return { value, label: value }
    })
  )
)

const connectorTypesSelectorHoc = (connectorTypesSelector) => (
  createSelector(
    entitiesSelector,
    connectorTypesSelector,
    (entities, refs) => refs.map(({id, type}) => {
      const value = entities[type][id].value
      return { value, label: value }
    })
  )
)

const locationsSelectorHoc = (locationsSelector) => (
  createSelector(
    entitiesSelector,
    locationsSelector,
    (entities, refs) => refs.map(({id, type}) => {
      const value = entities[type][id].value
      return { value, label: value }
    })
  )
)

const linksSelectorHoc = (linksSelector) => (
  createSelector(
    entitiesSelector,
    linksSelector,
    (entities, refs) => refs.map(({id, type}) => {
      const value = entities[type][id].value
      return { value, label: value }
    })
  )
)

export default (path) => {
  const withPath = createSelectorWithPath(path)
  const labelSelector = withPath(labelSelectorFunc)
  const valuesSelector = withPath(valuesSelectorFunc)
  const linksSelector = withPath(linksSelectorFunc)
  const locationsSelector = withPath(locationsSelectorFunc)
  const connectorTypesSelector = withPath(connectorTypesSelectorFunc)
  const connectorSourcesSelector = withPath(connectorSourcesSelectorFunc)
  const featuresSelector = withPath(featuresSelectorFunc)

  const linkSourceSelector = linksSelectorHoc(linksSelector)
  const locationSourceSelector = locationsSelectorHoc(locationsSelector)
  const connectorSourceSelector = connectorSourcesSelectorHoc(connectorSourcesSelector)
  const connectorTypeSourceSelector = connectorTypesSelectorHoc(connectorTypesSelector)
  const featureSourceSelector = featuresSelectorHoc(featuresSelector)

  return {
    valuesSelector,
    labelSelector,
    linkSourceSelector,
    locationSourceSelector,
    connectorSourceSelector,
    connectorTypeSourceSelector,
    featureSourceSelector,
  }
}

export {
  getValuesSelector
}
